function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 25.1503,
  cy: 25.1503,
  r: 23.8496,
  fill: "#DBAB02"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 23.8496,
  cy: 23.8496,
  r: 23.8496,
  fill: "#FCE48F"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 23.8492,
  cy: 23.8492,
  r: 19.0796,
  fill: "#F9CD2E"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M24.9335 28.8169L31.5214 32.7931L29.7731 25.2991L35.5935 20.2569L27.9289 19.596L24.9335 12.5391L21.938 19.596L14.2734 20.2569L20.0832 25.2991L18.3456 32.7931L24.9335 28.8169Z",
  fill: "#DBAB02"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M24.0663 28.3833L30.6542 32.3595L28.9059 24.8655L34.7263 19.8233L27.0617 19.1624L24.0663 12.1055L21.0708 19.1624L13.4062 19.8233L19.216 24.8655L17.4784 32.3595L24.0663 28.3833Z",
  fill: "#FCE48F"
});

function SvgMedal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedal);
export default __webpack_public_path__ + "static/media/medal.010724dc.svg";
export { ForwardRef as ReactComponent };